import type { SortDirection } from '@data/components/basic/Table/types';

export function buildOrderBy(
  sortColumn: string | undefined,
  sortDirection: SortDirection | undefined,
  searchTerms: string,
  userSorted: boolean
) {
  const shouldOrder =
    sortColumn && sortDirection && (!searchTerms || userSorted);

  if (!shouldOrder) {
    return {};
  }

  return {
    orderBy: [
      {
        key: sortColumn,
        order: sortDirection.toUpperCase() as 'ASC' | 'DESC',
      },
    ],
  };
}
